var _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-65156bb5-985b-450d-9ab2-e7a415d38997",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.04 42.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.13,31.32l16.63,10.45c.78.45,1.48.4,2.18-.05l12.61-6.72,9.5,5.95v-9.16s-2.04-1.22-4.78-2.97V.98c0-.51-.43-.94-.94-.94H1.16C.65.04.22.47.22.98v28.47c0,.93.19,1.33.91,1.87Zm7.15-5.87V8.41c0-.29.24-.53.53-.53h19.87c.29,0,.53.24.53.53v15.16c-5.47-3.48-10.54-6.64-10.63-6.64v9.16l5.76,3.66-5.17,2.48c-.34.19-.77.19-1.11,0l-9.49-6.18c-.3-.2-.3-.37-.3-.61Z",
    fill: "#00f783",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m95.88,22.73c0,3.56-1.92,5.07-4.5,5.07-2.37,0-4.05-1.43-4.05-4.21v-11.9l-5.27,2.52v10.03c0,5.44,3.39,8.46,7.73,8.46,2.74,0,4.87-1.02,6.09-2.86v2.29h5.27V11.69l-5.27,2.52v8.52Z",
    fill: "#421a84",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m114.75,11.12c-6.42,0-10.79,4.7-10.79,10.79s4.33,10.79,11.2,10.79c3.92,0,6.99-1.59,8.91-4.37l-4.25-2.45c-.9,1.19-2.54,2.04-4.58,2.04-2.78,0-5.03-1.14-5.76-3.84h15.41c.12-.69.2-1.39.2-2.17,0-6.01-4.29-10.79-10.34-10.79Zm-5.36,8.87c.61-2.62,2.53-4.13,5.36-4.13,2.21,0,4.42,1.19,5.07,4.13h-10.43Z",
    fill: "#421a84",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m132.42,17.5c0-1.1,1.06-1.68,2.37-1.68,1.51,0,2.66.78,3.27,2.09l4.5-2.45c-1.59-2.82-4.46-4.33-7.77-4.33-4.21,0-7.77,2.33-7.77,6.5,0,7.2,10.55,5.56,10.55,8.54,0,1.19-1.14,1.76-2.82,1.76-2.04,0-3.43-.98-4.01-2.66l-4.58,2.58c1.47,3.15,4.5,4.87,8.59,4.87,4.37,0,8.22-2.13,8.22-6.54,0-7.52-10.55-5.64-10.55-8.67Z",
    fill: "#421a84",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m150.44,4.9l-5.27,2.5v18.08c0,5.52,3.85,7.69,11.25,6.87v-4.78c-3.03.16-5.98.12-5.98-2.08v-8.5h5.98v-5.07h-5.98v-7.01Z",
    fill: "#421a84",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "160.2 5.15 159.34 6.47 158.49 5.15 157.67 5.15 157.67 8.29 158.49 8.29 158.49 6.48 159.31 7.73 159.39 7.73 160.2 6.47 160.2 8.29 161.02 8.29 161.02 5.15 160.2 5.15",
    fill: "#421a84",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "154.72 5.92 155.61 5.92 155.61 8.29 156.45 8.29 156.45 5.92 157.33 5.92 157.33 5.15 154.72 5.15 154.72 5.92",
    fill: "#421a84",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m78.48,17.94c0-8.38-6.62-14.88-14.88-14.88s-14.84,6.5-14.84,14.88,6.58,14.88,14.84,14.88c3.82,0,7.3-1.4,9.92-3.74l6.12,3.65v-6.21s-1.14-.69-2.82-1.7c1.06-2.05,1.65-4.39,1.65-6.89Zm-14.88,9.36c-5.19,0-9.24-3.88-9.24-9.36s4.05-9.4,9.24-9.4,9.24,3.88,9.24,9.4c0,1.46-.29,2.81-.81,4-4.19-2.51-8.56-5.12-8.64-5.12v6.21l5.03,3c-1.39.82-3.03,1.27-4.81,1.27Z",
    fill: "#421a84",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8d21bbcf41c4178577f2b6cbefa666e8.svg";
export { ForwardRef as ReactComponent };